export default () => `
    id
    org
    companyName
    patentLostDate
    drugDescription
    createdDate
    createdBy
`;
